import { render, staticRenderFns } from "./TwoFAForm.vue?vue&type=template&id=6ef5fb10&"
import script from "./TwoFAForm.vue?vue&type=script&lang=js&"
export * from "./TwoFAForm.vue?vue&type=script&lang=js&"
import style0 from "./TwoFAForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports